<template>
  <div class="floatingPage"
    :style="pageSize"
    :class="pagePosition">
    <Page v-if="page"
      :id="page"
      :locale="locale"
      :lang="lang"
      :responsive="responsive"
      :translateType="translateType"
      :guestType="guestType"
      :roomKey="roomKey" />
  </div>
</template>

<script>
import Page from '@/components/LayerPopup/Index.vue' // view/Page.vue가 store를 사용하기 때문에 모든 레이어페이지가 동일하게 뜨는 문제로 독립된 layerpopup page 분리

export default {
  name: 'FloatingPage',
  props: [
    'locale',
    'lang',
    'responsive',
    'translateType',
    'guestType',
    'roomKey',
    'isPublic',
    'layerpopup',
    'site'
  ],
  components: {
    Page
  },
  computed: {
    page () {
      return this.$store.getters['floating/getFloatingPage']
    },
    style () {
      const styles = this.$store.getters['floating/getFloatingPageStyle']
      if (!styles) return null
      const position = styles.floatingPagePos
      const size = styles.floatingPageSize
      return {
        position: position,
        size: size
      }
    },
    pageSize () {
      const style = this.style
      if (!style) return null
      const size = style.size || {}
      function getSize (s) {
        const pxOrRaw = (v) => (/^[0-9]+$/.test(String(v)) ? `${v}px` : v)
        return {
          '--mobile-w': s.mobileW || '100%',
          '--mobile-h': s.mobileH || '100%',
          '--tablet-w': pxOrRaw(s.tabletW || '100%'),
          '--tablet-h': pxOrRaw(s.tabletH || '100%'),
        }
      }
      return {
        ...getSize(size)
      }
    },
    pagePosition () {
      const style = this.style
      if (!style) return null
      const position = style.position || ''
      function getPosition (p) {
        const pos = (p || 'rb').toLowerCase()
        const x = pos[0] || 'r'
        const y = pos[1] || 'b'

        return {
          'pos-l': x === 'l',
          'pos-r': x === 'r',
          'pos-xc': x === 'c',

          'pos-t': y === 't',
          'pos-b': y === 'b',
          'pos-yc': y === 'c',
        }
      }
      return {
        ...getPosition(position)
      }
    }
  },
  created () {
  },
  mounted () {
  },
  destroyed () {
    document.body.classList.remove('layerOn')
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.floatingPage {
  width: var(--mobile-w, 100%);
  height: var(--mobile-h, 100%);
}
/* x축: left/center/right */
.floatingPage.pos-l { left: var(--pad); }
.floatingPage.pos-r { right: var(--pad); }
.floatingPage.pos-xc { left: 50%; transform: translateX(-50%); }

/* y축: top/center/bottom */
.floatingPage.pos-t { top: var(--pad); }
.floatingPage.pos-b { bottom: var(--pad); }
.floatingPage.pos-yc { top: 50%; transform: translateY(-50%); }

/* x,y 둘다 center */
.floatingPage.pos-xc.pos-yc { transform: translate(-50%, -50%); }

@media (min-width: 768px) {
  .floatingPage {
    width: var(--tablet-w, 100%);
    height: var(--tablet-h, 100%);
  }
}
</style>
